import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

import { prepareOwnersToClient } from "./to-client/prepareOwnerToClient";
import prepareLocationsToClient from "./to-client/prepareSectorToClient";
import prepareFeaturesToClient from "./to-client/prepareFeaturesToClient";
import prepareBusinessTypeToClient from "./to-client/prepareBusinessTypeToClient";
import {
  GetArrangementsType,
  GetConditionStatus,
  GetCurrencyType,
  GetProjectType
} from "./to-client/prepareExtrasArray";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import preparePicturesToClient from "./to-client/preparePicturesToClients";
import prepareDocumentsToClient from "./to-client/prepareDocumentsToClients";
import prepareVideosToClient from "./to-client/prepareVideosToClients";
import prepareSeoToClient from "./to-client/prepareSeoToClient";
import prepareAgentsToClient from "./to-client/prepareAgentsToClient";
import HFormatDate from "@rf-helper/format/format-date";
import prepareBuildingToClient from "./to-client/prepareBuildinsToClient";
import prepareValidationToClient from "./to-client/prepareValidationToClient";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { CPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";

const patchPropertyProjectAdapter = (
  data: IPropertyDetailsResponse
): IPropertyForm => {
  const owners = prepareOwnersToClient(data);
  const locations = prepareLocationsToClient(data);
  const features = prepareFeaturesToClient(data);
  const businessType = prepareBusinessTypeToClient(data);
  const arrangement = GetArrangementsType(data?.arrangement_id);
  const agentInfo = prepareAgentsToClient(data);
  const seo = prepareSeoToClient(data);
  const videos = prepareVideosToClient(data);
  const documents = prepareDocumentsToClient(data);
  const pictures = preparePicturesToClient(data);
  const building = prepareBuildingToClient(data);
  const validation = prepareValidationToClient(data);

  // TODO: Add the rest of the properties
  // @ts-ignore
  return {
    ...CPropertyForm,

    // validation documents
    ...validation,
    // ...caracteritics,
    id_property: data?.id,
    global_currency_property: GetCurrencyType(data?.currency_id),
    type_property: GetProjectType(data?.project?.projectype_id),
    name_property: data?.name ?? "",
    arrangement_type_property: arrangement as any[],
    business_types_property: businessType.business_type as any[],
    uses_property: features.use as any[],
    condition_property: GetConditionStatus(data.condition_status),
    associates_type_property: agentInfo.associates_type,
    master_broker_property: data.project?.master_broker ? true : false,
    price_maintenance_property: data?.maintenance_fee ?? "",
    currency_maintenance_property: GetCurrencyType(data?.maintenance_currency_id),
    currency_separation_property: GetCurrencyType(data?.currency_separation_id),
    price_separation_property: data?.separation_price,
    deadline_property: HFormatDate(data?.delivers, "form"),
    fee_sale_percentage_commission_property: data?.total_comission || "",
    fee_sale_selling_agent_commission_percentage: data?.guaranteed_comission || "",
    is_study_property: (data?.improvements_list?.some(
      imp => imp.feature_values_id == 28
    )
      ? [C_YES_AND_NOT.YES]
      : [C_YES_AND_NOT.NOT]) as any[],

    is_collection_property: (data?.is_collection
      ? [C_YES_AND_NOT.YES]
      : [C_YES_AND_NOT.NOT]) as any[],

    characteristics_frames_property: features.characteristics_frames as any[],
    characteristics_closets_property: features.characteristics_closets as any[],
    characteristics_door_property: features.characteristics_doors as any[],
    characteristics_windows_property: features.characteristics_windows as any[],
    characteristics_cabinets_property: features.characteristics_cabinets as any[],
    characteristics_floors_property: features.characteristics_floors as any[],
    features_property: features.features as any[],
    brokers_property: agentInfo.agents,
    characteristics_type_house_property:
      features.characteristics_type_house as any[],
    characteristics_roof_form_property: features.characteristics_roof_form as any[],
    characteristics_roof_property: features.characteristics_roof as any[],

    // location
    owners_property: owners as any[],
    city_property: locations.city,
    sector_property: locations.sector,
    latitude_property: locations.lat,
    longitude_property: locations.log,
    address_property: locations.address,
    reference_point_property: locations.reference,
    position_property: features.position as any[],

    // documents
    // tareas_property: data?.tarea ?? "",
    registration_number: data?.property_title_number ?? "",
    notes_property: data?.loan_note ?? "",
    have_mortgage_property: (data?.has_loan
      ? [C_YES_AND_NOT.YES]
      : [C_YES_AND_NOT.NOT]) as any[],

    // multimedia
    images_property: pictures as any[],
    drive_link_property: data?.google_drive_link ?? "",
    dropbox_link_property: data?.dropbox_link ?? "",
    tour_virtual_property: data?.realstate_tour_url ?? "",
    videos_property: videos,

    // documents
    file_title_property: documents.title,
    file_capture_details_property: documents.captureDetails,
    file_owner_id_property: documents.fileOwnerId,
    file_application_form_property: documents.fileApplicationForm,
    file_power_ownership_property: documents.filePowerOwnership,
    file_commercial_registry_property: documents.fileCommercialRegistry,
    file_property_contract_property: documents.filePropertyContract,

    // seo
    seo_description_en_property: seo.description_en,
    seo_keywords_en_property: seo.keywords_en,
    seo_short_description_en_property: seo.short_description_en,
    seo_title_en_property: seo.title_en,
    seo_description_es_property: seo.description_es,
    seo_keywords_es_property: seo.keywords_es,
    seo_short_description_es_property: seo.short_description_es,
    seo_title_es_property: seo.title_es,

    // building
    building
  };
};

export default patchPropertyProjectAdapter;
